export default __webpack_public_path__ + "static/media/Screen1.31ef3a0e.gif";